import React from 'react';
import { FiAlertTriangle } from 'react-icons/fi';

const GamblingWarning: React.FC = () => {
  return (
    <div className="bg-yellow-600 text-white py-3 px-4 text-center text-sm">
      <div className="container mx-auto flex items-center justify-center gap-3 flex-wrap">
        <FiAlertTriangle className="flex-shrink-0" size={20} />
        <p className="m-0">
          <strong>JEUX D'ARGENT ET DE HASARD PEUVENT ÊTRE DANGEREUX:</strong> PERTES D'ARGENT, CONFLITS FAMILIAUX, ADDICTION.
          RETROUVEZ NOS CONSEILS SUR{' '}
          <a
            href="https://www.joueurs-info-service.fr/"
            target="_blank"
            rel="noopener noreferrer"
            className="underline hover:text-yellow-200 font-semibold"
          >
            JOUEURS-INFO-SERVICE.FR
          </a>
          {' '}(09 74 75 13 13 - APPEL NON SURTAXÉ)
        </p>
      </div>
    </div>
  );
};

export default GamblingWarning;

